import model from 'modules/qrcodeTemplate/qrcodeTemplateModel';

const { fields } = model;

export default [
  fields.id,
  fields.type,
  fields.hbsContent,
  fields.company,
  fields.enable,
  fields.createdAt,
  fields.updatedAt
];
